export const dbmHideArea = () => {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            const currentElement = element[0];
            const parentElement = currentElement.parentNode;
            let childNodes = Array.from(parentElement.children);
            scope.$watch(() => attr.dbmHideArea, (newVal, oldVal) => {
                let index = 0;
                if(parentElement.children.length != childNodes.length)
                    childNodes = Array.from(parentElement.children);
                if (newVal === "false") {
                    for (let el of childNodes) {
                        if (index != 0)
                            parentElement.removeChild(el);
                        ++index;
                    }
                }
            });
        }
    };
};



// WEBPACK FOOTER //
// ./src/app/common/directives/dbm-hide-area.js